// Screenname:Group master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages: 
import httpbaseURL from '../common/axios';
class Groupservices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/GroupMAS/Create", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/GroupMAS/List")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/GroupMAS/Get?id=" + doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/GroupMAS/Update", doc)
    }
    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/GroupMAS/Delete?id=" + doc)
    }
    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "GroupMAS/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new Groupservices()